import { render, staticRenderFns } from "./edit-text-dialog.vue?vue&type=template&id=524e317c&scoped=true"
import script from "./edit-text-dialog.vue?vue&type=script&lang=ts"
export * from "./edit-text-dialog.vue?vue&type=script&lang=ts"
import style0 from "./edit-text-dialog.vue?vue&type=style&index=0&id=524e317c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524e317c",
  null
  
)

export default component.exports